import { render } from "./CardManageOtherSnd.vue?vue&type=template&id=3a195f4f"
import script from "./CardManageOtherSnd.vue?vue&type=script&lang=js"
export * from "./CardManageOtherSnd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__